import { ZoomOut } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ZoomOutIcon = DeckardIconWrapper({ Icon: ZoomOut });
